function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M28.92 68H2.67029e-05C2.00003 73.84 6.11002 78.14 10.73 81.91C15.35 85.68 20.8 87.73 26.63 88.91C28.63 89.33 28.94 88.63 28.92 86.91C28.87 80.62 28.91 74.31 28.92 68Z",
  fill: "#BDC7F8"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M97.4334 59.0005H103.853C104.159 58.9932 104.46 59.0789 104.716 59.2462C104.971 59.4134 105.171 59.6545 105.287 59.9373C105.403 60.2202 105.43 60.5316 105.365 60.8304C105.3 61.1291 105.146 61.4012 104.923 61.6105L98.5134 67.9605C98.3028 68.172 98.0343 68.3164 97.7417 68.3753C97.4491 68.4343 97.1456 68.4052 96.8696 68.2918C96.5935 68.1784 96.3572 67.9857 96.1906 67.7381C96.024 67.4904 95.9345 67.199 95.9334 66.9005L95.8834 60.5205C95.882 60.318 95.9214 60.1172 95.9991 59.9302C96.0769 59.7432 96.1915 59.5737 96.3361 59.4319C96.4807 59.2901 96.6524 59.1788 96.8409 59.1047C97.0294 59.0306 97.2309 58.9952 97.4334 59.0005V59.0005Z",
  fill: "#BDC7F8"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M96.3993 3.57051V18.6805C96.4044 19.3895 96.1977 20.0839 95.8056 20.6747C95.4136 21.2655 94.854 21.7258 94.1987 21.9965C93.5433 22.2672 92.8221 22.3361 92.1274 22.1943C91.4327 22.0525 90.7961 21.7064 90.2993 21.2005L75.2993 6.20051C74.7953 5.7055 74.4499 5.07171 74.3071 4.37981C74.1644 3.68791 74.2307 2.96918 74.4977 2.3151C74.7647 1.66102 75.2203 1.10116 75.8064 0.706796C76.3926 0.312427 77.0828 0.101378 77.7893 0.100507L92.7893 0.000508122C93.2622 -0.00749368 93.732 0.0790844 94.1709 0.255158C94.6099 0.431232 95.0093 0.693248 95.3456 1.02582C95.6819 1.3584 95.9483 1.75482 96.1293 2.19181C96.3102 2.6288 96.4021 3.09754 96.3993 3.57051V3.57051Z",
  fill: "#BDC7F8"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M143.399 173.5H94.8994C94.8994 152.237 112.136 135 133.399 135H146.399V170.5C146.399 172.157 145.056 173.5 143.399 173.5Z",
  fill: "#BDC7F8"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M61.3994 93H32.3994C30.1903 93 28.3994 94.7909 28.3994 97V124.731C28.3994 125.432 28.9677 126 29.6686 126V126C47.1931 126 61.3994 111.794 61.3994 94.2692V93Z",
  fill: "#BDC7F8"
});

var SvgOrnamentRight = function SvgOrnamentRight(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 174,
    viewBox: "0 0 147 174",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgOrnamentRight, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ornament-right.f6c98c0c.svg";
export { ForwardRef as ReactComponent };